import React from 'react';
import { NavLink } from 'react-router-dom';

const Irp5sCrumb = () => <NavLink to="/human-resources/irp5s">IRP5s</NavLink>;

export default Irp5sCrumb;
